import styled from "styled-components/macro";

export const RejectAllButton = styled.div`
position: absolute;
right: 10px; 
top: 3px;
width: fit-content; 
display: flex; 

@media (max-width: 991px) {
  top: 28px; 
}
`
